(function () {
    'use strict';

    angular
        .module('app.notes')
        .factory('notes', notes);

    notes.$inject = ['notesDialog', 'opsIncludeVersion', 'dataservice', 'common'];

    /* @ngInject */
    function notes(notesDialog, opsIncludeVersion, dataservice, common) {
        var service = {
            show: show,
            notesShowing: null, 
            notesCloseCallback: null
        };

        return service;

        function show(i, $event) {

            if (i.TaskId > 0) {
                var tAsM = moment(common.getMainState("mainDate"));
                var d = tAsM.format("YYYY-MM-DD");

                var thatI = i;

                dataservice.getItem("api/DailySetup/GetNotesForTask/" + i.TaskId + "/" + d).then(function (res) {
                    thatI.Notes = res.data;
                    
                    $event.preventDefault();
                    $event.stopPropagation();
                    if (service.notesShowing) {
                        service.notesShowing();
                    }
                    var title = thatI.BookingId > 0 ? thatI.EventName : thatI.TaskDescription;
                    return notesDialog.show(title, "app/notes/_notes.html?v=" + opsIncludeVersion, thatI).then(function () {
                        if (service.notesCloseCallback) {
                            service.notesCloseCallback();
                        }
                    }, function () { });

                }).catch(function (resError) {
                    console.log(resError);
                });
                
               
            }


           
        }
    }
}());
